<template>
  <el-container>
    <el-main style="padding: 0">
      <span>生产下料扫描</span>
      <el-divider />
      <el-form ref="form" class="form" label-width="80px" @submit.native.prevent>
        <el-form-item label="产线编号" style="width: 500px">
          <el-input
            ref="firstInput"
            v-model.trim="model.workCenterNo"
            placeholder="请扫描产线编号"
            @keyup.enter.native="scanWorkCenterNo"
          />
        </el-form-item>
        <el-form-item label="产品序列号" style="width: 500px">
          <el-input
            ref="secondInput"
            v-model.trim="model.strNo"
            :disabled="secondDisabled"
            placeholder="请扫描产品序列号"
            @keyup.enter.native="scanStrNo"
          />
        </el-form-item>
        <el-form-item label="库位编号" style="width: 500px">
          <el-input
            ref="thirdInput"
            v-model.trim="model.locationCode"
            :disabled="thirdDisabled"
            placeholder="请扫描库位编号"
            @keyup.enter.native="scanlocationCode"
          />
        </el-form-item>
        <el-form-item>
          <el-table :data="tableData" border>
            <el-table-column prop="materialSn" align="center" label="产品序列号" width="160" />
            <el-table-column prop="materialNo" align="center" label="物料号" width="140" />
            <el-table-column prop="materialName" align="left" label="物料名称" show-overflow-tooltip min-width="175" />
            <el-table-column prop="code" align="center" label="库存编号" width="100" />
            <el-table-column prop="locationName" align="left" label="库存名称" show-overflow-tooltip min-width="120" />
            <el-table-column prop="quantity" align="center" label="库存数量" width="80" />
            <el-table-column prop="unitName" align="center" label="单位" width="60" />
            <!-- <el-table-column prop="" align="left" label="长"/> -->
            <el-table-column prop="materialWidth" align="center" label="宽" width="60" />
            <el-table-column prop="materialHeight" align="center" label="高" width="60" />
            <el-table-column prop="note" align="left" label="备注" show-overflow-tooltip min-width="140" />
            <el-table-column label="操作" align="center" prop="action" width="80">
              <template slot-scope="scope">
                <el-button type="primary" @click="printCode(scope.row)"> 打印 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-main>
    <!-- 产品序列号打印 -->
    <!-- <material-code-modal ref="materialCodeModal" /> -->
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      model: {
        workCenterNo: "", // 产线编号
        locationCode: "", // 库位编号
        strNo: "", // 产品序列号
      },
      tableData: [],
      secondDisabled: true,
      thirdDisabled: true,
    };
  },

  mounted() {
    this.$refs.firstInput.focus();
  },

  methods: {
    // 扫描产线编号,查询产品序列号
    scanWorkCenterNo() {
      if (this.model.workCenterNo) {
        const params = {
          workCenterNo: this.model.workCenterNo,
        };
        this.$http.post("basic", "productionScan/getWorkCenterMaterialList", params).then((resp) => {
          if (resp.success) {
            this.tableData = resp.data;
            this.secondDisabled = false;
            this.$nextTick(() => {
              this.$refs.secondInput.focus();
            });
          } else {
            this.model.workCenterNo = "";
          }
        });
      }
    },

    // 扫描产品序列号
    scanStrNo() {
      if (this.model.strNo) {
        this.thirdDisabled = false;
        this.$nextTick(() => {
          this.$refs.thirdInput.focus();
        });
      }
    },

    // 扫描库位编号 并提交
    scanlocationCode() {
      if (this.model.locationCode) {
        if (!this.model.workCenterNo) {
          this.$confirm("产线编号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.$refs.firstInput.focus();
          return;
        }
        if (!this.model.strNo) {
          this.$confirm("产品序列号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.$refs.secondInput.focus();
          return;
        }
        this.$http.post("basic", "productionScan/scanProductionLineMaterialReturn", this.model).then((resp) => {
          if (resp.success) {
            this.$message.success("下料成功");
            this.model = {};
            this.$refs.firstInput.focus();
          }
        });
      }
    },

    // 打印产品序列号
    printCode(row) {
      const params = {
        billNo: this.orderInfo.billNo,
        salesOrderNo: this.orderInfo.salesOrderNo,
        data: [
          {
            itemSn: row,
          },
        ],
      };
      const routeUrl = this.$router.resolve({
        path: "/materialsTagsPrint",
        query: {
          params: params,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
